module.exports = __webpack_public_path__ + "img/history.101b357d.svg";